export default __webpack_public_path__ + "static/media/keywords.0195de6c.svg";